const {ITEM_ROLE_PERMISSIONS} = require('am-constants');

function getPermissionsForRoles (roles) {
  return roles.reduce((prev, curr) => [...prev, ...ITEM_ROLE_PERMISSIONS[curr]], []);
}

module.exports = getPermissionsForRoles;
